import { z } from 'zod';

import { blockBaseSchema } from '../base';
import { blockCommonDataShape } from '../shared';

/**
 * A free-positioning canvas. Its widgets are placed absolutely, so it always
 * carries a `height` — the shared one from `blockCommonDataShape`, which a
 * canvas reads as an exact height rather than as a minimum.
 */
export const blockZeroDataSchema = z.object({
    ...blockCommonDataShape,

    /** Clips whatever a widget pushes past the canvas edge. */
    hideOverflow: z.boolean(),
});

export const blockZeroSchema = blockBaseSchema.extend({
    entitySubType: z.literal('zero'),
    props: blockZeroDataSchema,
    version: z.literal(0),
});

export const blockZeroV0Schema = blockZeroSchema;
export type BlockZeroV0 = z.infer<typeof blockZeroV0Schema>;
